var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5007 8H18.5007C17.7643 8 17.1673 8.59696 17.1673 9.33333V13.3333H22.5007C22.6523 13.33 22.7961 13.4005 22.8863 13.5225C22.9764 13.6445 23.0017 13.8027 22.954 13.9467L21.9673 16.88C21.8764 17.1492 21.6248 17.3312 21.3407 17.3333H17.1673V27.3333C17.1673 27.7015 16.8688 28 16.5007 28H13.1673C12.7991 28 12.5007 27.7015 12.5007 27.3333V17.3333H10.5007C10.1325 17.3333 9.83398 17.0348 9.83398 16.6667V14C9.83398 13.6319 10.1325 13.3333 10.5007 13.3333H12.5007V9.33333C12.5007 6.38781 14.8885 4 17.834 4H22.5007C22.8688 4 23.1673 4.29848 23.1673 4.66667V7.33333C23.1673 7.70152 22.8688 8 22.5007 8Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5dae4fe5a56ebe1e81338cc12e44371f.svg";
export { ForwardRef as ReactComponent };